import { render } from "./DocumentCard.vue?vue&type=template&id=663ce7c9&scoped=true"
import script from "./DocumentCard.vue?vue&type=script&lang=js"
export * from "./DocumentCard.vue?vue&type=script&lang=js"

import "./DocumentCard.vue?vue&type=style&index=0&id=663ce7c9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663ce7c9"]])

export default __exports__